import { render } from "./SectionGallery.vue?vue&type=template&id=0f197b1e&scoped=true"
import script from "./SectionGallery.vue?vue&type=script&lang=js"
export * from "./SectionGallery.vue?vue&type=script&lang=js"

import "./SectionGallery.vue?vue&type=style&index=0&id=0f197b1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f197b1e"]])

export default __exports__